import { action } from 'satcheljs';
import ComposeViewState from '../store/schema/ComposeViewState';

/**
 * Action triggered when S/MIME options are changed
 */
export default action(
    'onSmimeOptionsChange',
    (
        viewState: ComposeViewState,
        shouldEncryptMessageAsSmime: boolean,
        shouldSignMessageAsSmime: boolean
    ) => ({
        viewState,
        shouldEncryptMessageAsSmime,
        shouldSignMessageAsSmime,
    })
);

/**
 *  Action triggered to mutate the viewstate when S/MIME option is changed
 */
export const onSmimeOptionsDirty = action(
    'onSmimeOptionsDirty',
    (
        viewState: ComposeViewState,
        shouldEncryptMessageAsSmime: boolean,
        shouldSignMessageAsSmime: boolean
    ) => ({
        viewState,
        shouldEncryptMessageAsSmime,
        shouldSignMessageAsSmime,
    })
);
